export default "__VITE_ASSET__CnKRLgSB__"